export enum SettingsKeys {
  ProjectsGrid = "projects-grid-settings",
  OpenProjectsGrid = "open-projects-grid-settings",
  OpcoProjectsGrid = "opco-projects-grid-settings",
  PavedRoadsProjectsGrid = "paved-roads-projects-grid-settings",
  PendingRequestsGrid = "pending-requests-grid-settings",
  ProcessedRequestsGrid = "processed-requests-grid-settings",
  ProjectHistoryGrid = "project-history-grid-settings",
  ProjectUsersGrid = "project-users-settings",
  ProjectUsersExpanded = "project-users-expanded",
  ProjectToolsExpanded = "project-tools-expanded",
  Banner = "banner",
}
